// @ts-expect-error TS(7016): Could not find a declaration file for module '@nos...
import SortableTree from "@nosferatu500/react-sortable-tree"
import { ProgressSpinner } from "primereact/progressspinner"

import "./categoriasTree.scss"

const CategoriasTree = ({
  visible = true,
  items,
  setItems,
  onMoveItem,
  onClick,
  loading = false,
  canEdit = true,
}: $TSMigrationFixMe) => {
  if (!visible) return null

  const editCategoria = (e: $TSMigrationFixMe, node: $TSMigrationFixMe) => {
    e.stopPropagation()
    onClick?.(node)
  }

  return (
    <div className='container-tree'>
      <div className='categorias-tree-wrap'>
        {loading ? (
          <ProgressSpinner
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        ) : (
          <SortableTree
            canDrop={() => canEdit}
            treeData={items}
            onChange={(changes: $TSMigrationFixMe) => setItems(changes)}
            onMoveNode={onMoveItem}
            generateNodeProps={({ node }: $TSMigrationFixMe) => ({
              title: (
                <div
                  onClick={(e) => editCategoria(e, node)}
                  className='h-100 w-100 d-flex align-items-center'
                  style={{ cursor: "pointer" }}
                >
                  {node.title}{" "}
                  <span className='ml-2'>({node.cantidadArticulos})</span>
                </div>
              ),
            })}
          />
        )}
      </div>
    </div>
  )
}

export default CategoriasTree
